import { apiAgent } from "./axiosConfig"
import getApiUrl from "./components/utils/UrlHelper"

export const logoutApi = () => {
    return apiAgent({
        method: "post",
        url: getApiUrl('logout'),
        data: {}
    })
}

export const team_members = (data_params) => {
    return apiAgent({
        menthod: "get",
        url: getApiUrl("get_team_members"),
        params: data_params,
    })
}